export const articles = [
  {
    id: 1,
    title: "LDC – Quarts de finale : PSG vs Liverpool et Real Madrid vs Bayern au programme",
    pubDate: new Date(Date.now() - 2 * 3600000).toISOString(),
    thumbnail: null,
    category: "Ligue des Champions",
    body: `Le tirage des quarts de finale de l'UEFA Champions League 2025-2026 a livré deux affiches de prestige. Le Paris Saint-Germain, qualifié après une démonstration historique face à Chelsea (8-2 au total), défiera Liverpool les 8 et 14 avril. Le Real Madrid, de son côté, affrontera le Bayern Munich les 8 et 15 avril.

PSG vs Liverpool : les Parisiens recevront les Reds au Parc des Princes pour le match aller le 8 avril, avant de se déplacer à Anfield le 14 avril. Liverpool avait validé son billet grâce à une large victoire face à Galatasaray (4-0, 4-1 au total) avec des buts de Szoboszlai, Ekitike, Gravenberch et Salah.

Real Madrid vs Bayern Munich : le match aller se jouera au Bernabéu le 8 avril, le retour à l'Allianz Arena le 15 avril. Le Real avait éliminé Manchester City en huitièmes, tandis que le Bayern avait sorti l'Atalanta.

La finale est programmée le 30 mai 2026 à Budapest.`,
  },
  {
    id: 2,
    title: "PSG 8-2 Chelsea : la démonstration parisienne qui a ébranlé l'Europe",
    pubDate: new Date(Date.now() - 5 * 3600000).toISOString(),
    thumbnail: null,
    category: "Ligue des Champions",
    body: `Paris Saint-Germain a réalisé l'une des performances les plus retentissantes de son histoire européenne en éliminant Chelsea avec un bilan cumulé de 8-2 sur les deux matchs des huitièmes de finale de la Ligue des Champions.

Après un match aller déjà très favorable, les Parisiens ont enfoncé les Blues au retour dans une soirée de gala au Parc des Princes. Cette qualification retentissante place le PSG parmi les sérieux prétendants au titre cette saison.

Les Parisiens, tenants du titre en Ligue 1 avec un large avance au classement, ont démontré une maturité tactique et une efficacité offensive rare sur la scène européenne. Leur prochain adversaire, Liverpool, sera autrement plus coriace.

Le choc contre les Reds de Slot s'annonce comme l'un des grands moments du printemps européen, avec deux clubs en pleine confiance.`,
  },
  {
    id: 3,
    title: "Ligue 1 : PSG – Toulouse et Monaco – OM au menu du week-end",
    pubDate: new Date(Date.now() - 8 * 3600000).toISOString(),
    thumbnail: null,
    category: "Ligue 1",
    body: `La 30e journée de Ligue 1 McDonald's proposera plusieurs affiches intéressantes ce week-end. En tête d'affiche, le PSG reçoit Toulouse ce vendredi 3 avril au Parc des Princes, avec l'objectif de confirmer leur domination en championnat avant le choc européen face à Liverpool.

Dimanche, le Rocher sera en feu lors du classique Monaco – Marseille. Les hommes d'Adi Hütter, qui pointent à la deuxième place, tenteront de creuser l'écart sur leurs poursuivants. L'OM, en pleine forme récente, visera un résultat positif dans ce derby de la Méditerranée.

Au programme également : Strasbourg-Nice et Brest-Rennes le samedi, ainsi qu'Angers-Lyon, Metz-Nantes, Le Havre-Auxerre et Lorient-Paris FC le dimanche.

Lens recevra le PSG lors de la journée suivante (10-12 avril), dans un match très attendu entre deux des meilleures équipes du championnat.`,
  },
  {
    id: 4,
    title: "Coupe du Monde 2026 : les 48 équipes sont connues, l'Irak décroche le dernier billet",
    pubDate: new Date(Date.now() - 12 * 3600000).toISOString(),
    thumbnail: null,
    category: "Coupe du Monde",
    body: `Les 48 équipes qui participeront à la Coupe du Monde 2026 aux États-Unis, au Canada et au Mexique sont désormais connues. C'est l'Irak qui a décroché la 48e et dernière place en battant la Bolivie lors des barrages intercontinentaux.

En finale des barrages intercontinentaux, la RD Congo a également validé sa qualification en écartant la Jamaïque (1-0 après prolongations), signant ainsi le retour historique de la nation africaine dans un Mondial pour la première fois depuis 1974, lorsqu'elle se nommait encore le Zaïre.

Du côté des barrages européens, la Suède, la Turquie, la République tchèque et la Bosnie-Herzégovine ont obtenu leur billet pour la compétition.

Le tournoi se déroulera du 11 juin au 19 juillet 2026, dans 16 stades répartis sur les trois pays hôtes. C'est la première édition à 48 équipes de l'histoire de la compétition.`,
  },
  {
    id: 5,
    title: "Mercato : le PSG vise Mohamed Salah pour l'été, Gonçalo Ramos sur le départ",
    pubDate: new Date(Date.now() - 18 * 3600000).toISOString(),
    thumbnail: null,
    category: "Transferts",
    body: `Le Paris Saint-Germain prépare activement son mercato estival avec une piste XXL : Mohamed Salah. L'attaquant égyptien de Liverpool (33 ans), dont le contrat expire en juin 2026, serait la priorité numéro une du club de la capitale pour renforcer son secteur offensif.

Dans le sens des départs, Gonçalo Ramos serait susceptible de quitter le PSG lors du prochain mercato estival. L'attaquant portugais, dans l'ombre des autres stars parisiennes, cherche un projet où il pourrait être davantage mis en valeur.

Le PSG explore également d'autres pistes pour son milieu de terrain, avec notamment Khéphren Thuram (25 ans, Juventus) qui réalise une très bonne saison en Serie A et représente un profil très apprécié par les recruteurs parisiens.

Du côté de Liverpool, le départ annoncé de Salah oblige le club anglais à anticiper un recrutement ambitieux avec la volonté de recruter deux ailiers de très haut niveau pour l'été 2026.`,
  },
  {
    id: 6,
    title: "Mercato : Newcastle s'intéresse à Robin Risser, le portier de Lens",
    pubDate: new Date(Date.now() - 24 * 3600000).toISOString(),
    thumbnail: null,
    category: "Transferts",
    body: `Newcastle United s'intéresse de très près au portier du RC Lens Robin Risser (21 ans), séduit par son profil moderne et sa remarquable qualité de jeu au pied. Le jeune gardien alsacien s'est imposé comme l'un des meilleurs de Ligue 1 cette saison et attire la convoitise des grands clubs européens.

Le club anglais, en pleine montée en puissance depuis le rachat par le consortium saoudien, cherche à recruter un gardien capable de s'inscrire dans la durée. Risser, formé à Strasbourg, correspondrait parfaitement aux critères des Magpies.

Le RC Lens, qui dispute une belle saison en championnat, devrait demander un montant important pour céder son portier, estimé aux alentours de 30 à 40 millions d'euros selon les médias spécialisés.

D'autres clubs anglais seraient également sur les rangs pour le jeune international espoirs français.`,
  },
  {
    id: 7,
    title: "Mercato : Casemiro vers l'Arabie saoudite en fin de saison",
    pubDate: new Date(Date.now() - 30 * 3600000).toISOString(),
    thumbnail: null,
    category: "Transferts",
    body: `Casemiro, le milieu défensif brésilien de Manchester United (34 ans), serait ouvert à un départ vers l'Arabie saoudite à l'issue de la saison. Son contrat avec les Red Devils expire en juin 2026 et une prolongation ne semble pas à l'ordre du jour.

Le joueur, estimé à environ 8 millions d'euros, est courtisé par plusieurs clubs de Saudi Pro League qui souhaitent profiter de sa disponibilité pour signer un nom de prestige. Cette piste s'inscrit dans la tendance récente d'anciens joueurs de Premier League rejoignant le championnat saoudien.

À Manchester United, sa saison a été perturbée par des blessures et ses performances en demi-teinte ont accéléré la réflexion sur son avenir. Ruben Amorim, le manager des Red Devils, s'appuie davantage sur un profil plus jeune et mobile au milieu.

Une annonce officielle sur son avenir pourrait intervenir en fin de saison.`,
  },
  {
    id: 8,
    title: "Équipe de France : les Bleus en route vers le Mondial 2026, le calendrier des qualifications",
    pubDate: new Date(Date.now() - 36 * 3600000).toISOString(),
    thumbnail: null,
    category: "Équipe de France",
    body: `L'équipe de France est en bonne position dans ses éliminatoires pour la Coupe du Monde 2026, après plusieurs résultats positifs lors des dernières journées. Les Bleus de Didier Deschamps ont jusqu'en novembre 2025 pour valider leur qualification directe.

Les prochains matchs de qualification s'annoncent décisifs. La sélection nationale peut s'appuyer sur un groupe dense et talentueux, avec notamment les cadres du Real Madrid, Kylian Mbappé et Eduardo Camavinga, en grande forme sur la scène européenne cette saison.

La bonne nouvelle vient aussi des jeunes générations, avec plusieurs joueurs de moins de 23 ans qui s'imposent progressivement en club et frappent à la porte de la sélection A.

La France, habituée à faire partie des prétendants sérieux en Coupe du Monde, visera naturellement une place dans le dernier carré d'un tournoi américain qui promet d'être exceptionnel avec 48 équipes.`,
  },
  {
    id: 9,
    title: "Barrages européens Mondial 2026 : Suède, Turquie, Tchéquie et Bosnie qualifiées",
    pubDate: new Date(Date.now() - 48 * 3600000).toISOString(),
    thumbnail: null,
    category: "Coupe du Monde",
    body: `Les barrages européens de qualification pour la Coupe du Monde 2026 ont rendu leur verdict. La Suède, la Turquie, la République tchèque et la Bosnie-Herzégovine ont validé leur ticket pour le Mondial américain qui se déroulera du 11 juin au 19 juillet 2026.

La Suède retrouve une grande compétition internationale après l'échec de ne pas s'être qualifiée pour le dernier Mondial. La Turquie, portée par ses joueurs évoluant dans les grands championnats européens, s'est imposée lors d'un barrage très serré. La République tchèque et la Bosnie complètent le tableau des qualifiés européens issus des barrages.

Ces qualifications s'ajoutent aux 12 équipes européennes qui avaient obtenu leur billet directement via les groupes de qualification. L'UEFA envoie ainsi 16 nations en tout au Mondial 2026, une augmentation par rapport aux éditions précédentes liée au passage à 48 équipes.

La compétition s'annonce particulièrement ouverte avec plus de représentants de chaque confédération.`,
  },
  {
    id: 10,
    title: "RD Congo qualifiée pour le Mondial 2026 pour la première fois depuis 1974",
    pubDate: new Date(Date.now() - 52 * 3600000).toISOString(),
    thumbnail: null,
    category: "Coupe du Monde",
    body: `La République Démocratique du Congo a réalisé l'exploit historique de se qualifier pour la Coupe du Monde 2026 en battant la Jamaïque (1-0 après prolongations) lors des barrages intercontinentaux. C'est la première qualification des Léopards dans un Mondial depuis 1974, époque à laquelle le pays s'appelait le Zaïre.

La rencontre, très serrée, a été décidée dans les prolongations lors d'un but salvateur qui a provoqué une explosion de joie au sein de la délégation congolaise et dans tout le pays.

Cette qualification est le fruit d'années de travail et de développement du football en RDC, avec une génération de joueurs qui s'impose progressivement dans les championnats européens. C'est un moment historique pour le football africain.

L'Irak a de son côté décroché le 48e et dernier billet du tournoi en battant la Bolivie dans l'autre finale des barrages intercontinentaux.`,
  },
  {
    id: 11,
    title: "Liverpool 4-0 Galatasaray : les Reds en quarts de finale, cap sur le PSG",
    pubDate: new Date(Date.now() - 60 * 3600000).toISOString(),
    thumbnail: null,
    category: "Ligue des Champions",
    body: `Liverpool a validé sa qualification pour les quarts de finale de la Ligue des Champions avec une large victoire face à Galatasaray (4-0) à Anfield, le 18 mars, bouclant le dossier sur un score cumulé de 4-1.

Dominik Szoboszlai, Hugo Ekitike, Ryan Gravenberch et Mohamed Salah ont été les buteurs de cette soirée de gala pour les Reds, qui ont livré une performance de haute intensité devant leur public.

Cette qualification place Liverpool dans le tableau des quarts de finale où les hommes de Slot affronteront le tenant du titre, le Paris Saint-Germain. Un choc titanesque en perspective les 8 et 14 avril prochains.

L'enjeu sera immense pour les deux équipes, avec d'un côté un PSG en grande forme en Ligue 1 et des Reds qui restent sur un parcours européen impressionnant depuis le début de la saison.`,
  },
  {
    id: 12,
    title: "Real Madrid élimine Manchester City en huitièmes : cap sur le Bayern",
    pubDate: new Date(Date.now() - 72 * 3600000).toISOString(),
    thumbnail: null,
    category: "Ligue des Champions",
    body: `Le Real Madrid a poursuivi sa tradition de grands exploits européens en éliminant Manchester City en huitièmes de finale de la Ligue des Champions 2025-2026. Les Merengues ont montré toute leur expérience dans les grands soirs pour voir venir les Cityzens et s'imposer au fil des deux manches.

Cette qualification place le Real Madrid en quarts de finale face au Bayern Munich, un choc entre deux mastodontes du football européen qui se connaissent parfaitement. Les deux équipes se sont affrontées à de nombreuses reprises en C1, avec des rencontres toujours au sommet.

Le match aller se jouera le 8 avril au Bernabéu, un antre où le Real est pratiquement invincible sur la scène européenne. Le retour à l'Allianz Arena le 15 avril promet également un spectacle de haute tenue.

Côté Bayern, le club bavarois avait sorti l'Atalanta au tour précédent dans un double confrontation très disputé.`,
  },
];
